<template>
  <div>
    <b-modal
      id="modal-scrollable"
      ref="my-modal"
      scrollable
      size="lg"
      title="Importação de valores"
      @ok="modalOk"
    >
      <div>
        <b-form-group
          label="Valores importar (cada linha será um novo valor)"
          label-for="ImportValues"
        >
          <b-form-textarea
            id="ImportValues"
            class="import-textarea"
            placeholder="Valores importar"
            v-model="importValues"
          />
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-table-simple hover small caption-top responsive>
      <b-thead>
        <b-tr>
          <b-th v-for="field in tableFieldsValores" :key="field.key">
            {{ field.label }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="row in activetableRowsList">
          <b-tr>
            <b-td class="td-id">
              {{ row.item.sequenciaExibicao }}
            </b-td>
            <b-td class="td-input">
              <b-form-input class="valor" type="text" v-model="row.item.valor">
              </b-form-input>
            </b-td>
            <b-td class="td-acoes">
              <table-form-resequence
                class="d-inline"
                :item="row.item"
                :items="items"
                :display-name="row.item.nome"
                :title="$t('checklist.form.fieldOptionResequence')"
                v-b-tooltip.hover
              >
              </table-form-resequence>
              <b-button
                size="sm"
                class="ml-1"
                :title="$t('checklist.form.fieldOptionDelete')"
                v-b-tooltip.hover
                @click="deleteValue(row.item)"
              >
                X
              </b-button>
              <b-button
                size="sm"
                class="ml-1"
                :title="$t('checklist.form.fieldOptionClone')"
                v-b-tooltip.hover
                @click="cloneValue(row.item, items)"
              >
                <i class="tim-icons icon-single-copy-04"></i>
              </b-button>
              <b-button
                size="sm"
                class="ml-1"
                :title="$t('checklist.form.fieldOptionConfigShow')"
                v-b-tooltip.hover
                @click="displayConfig(row)"
              >
                <i class="tim-icons icon-settings-gear-63"></i>
              </b-button>
              <b-button
                v-if="allowAddFields == true"
                size="sm"
                class="ml-1"
                :title="$t('checklist.form.fieldOptionAdditionalShow')"
                v-b-tooltip.hover
                @click="setPossuiCamposAdicionais(row)"
              >
                <i
                  v-if="row.detailsShowing"
                  class="tim-icons icon-simple-delete"
                ></i>
                <i v-else class="tim-icons icon-simple-add"></i>
              </b-button>
            </b-td>
          </b-tr>

          <!-- Configurações inicio -->
          <b-tr class="b-table-details" v-if="row.configShowing">
            <b-td :colspan="tableFieldsValores.length">
              <h4>
                {{ $t("checklist.form.fieldOptionConfig") }}:
                {{ row.item.valor }}
              </h4>
              <b-row>
                <b-col sm="12" md="2">
                  <b-form-group label="Gera pendência" label-for="geraAnomalia">
                    <b-form-select
                      id="geraAnomalia"
                      class="select-boolean"
                      :options="optionsAnomaly"
                      v-model="row.item.geraAnomalia"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                  <b-form-group
                    v-if="row.item.geraAnomalia != 1"
                    label="Prioridade"
                    label-for="pendencyPriority"
                  >
                    <pendency-priority-dropdown
                      id="pendencyPriority"
                      class="select-boolean"
                      :model.sync="row.item.pendencyPriority"
                    >
                    </pendency-priority-dropdown>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                  <b-form-group
                    v-if="row.item.geraAnomalia != 1"
                    label="Pendências únicas"
                    label-for="pendencyUniqueOpened"
                  >
                    <pendency-unique-opened-dropdown
                      id="pendencyUniqueOpened"
                      class="select-boolean"
                      :model.sync="row.item.pendencyUniqueOpened"
                    >
                    </pendency-unique-opened-dropdown>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                  <b-form-group
                    v-if="row.item.geraAnomalia != 1"
                    label="Notificar geração"
                    label-for="pendencyGenerationNotify"
                  >
                    <pendency-generation-notify-dropdown
                      id="pendencyGenerationNotify"
                      class="select-boolean"
                      :model.sync="row.item.pendencyGenerationNotify"
                    >
                    </pendency-generation-notify-dropdown>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" md="4">
                  <b-form-group
                    v-if="row.item.geraAnomalia != 1"
                    :label="$t('checklist.form.profilesPendencyApprover')"
                    label-for="profilesPendencyApprover"
                  >
                    <multiselect
                      id="profilesPendencyApprover"
                      class="select-field"
                      v-model="row.item.profilesApprover"
                      label="displayName"
                      track-by="id"
                      :placeholder="
                        $t('checklist.form.profilesPendencyApprover')
                      "
                      :close-on-select="false"
                      :showLabels="false"
                      :multiple="true"
                      :options="profiles"
                    >
                    </multiselect>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                  <b-form-group
                    v-if="row.item.geraAnomalia != 1"
                    :label="$t('checklist.form.profilesPendencyViewer')"
                    label-for="profilesPendencyViewer"
                  >
                    <multiselect
                      id="profilesPendencyViewer"
                      class="select-field"
                      v-model="row.item.profilesViewer"
                      label="displayName"
                      track-by="id"
                      :placeholder="$t('checklist.form.profilesPendencyViewer')"
                      :close-on-select="false"
                      :showLabels="false"
                      :multiple="true"
                      :options="profiles"
                    >
                    </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>
              <div v-if="row.item.geraAnomalia == 2">
                <pendency-due-date-crud
                  :dueDate.sync="row.item.pendencyDueDate"
                ></pendency-due-date-crud>
              </div>
            </b-td>
          </b-tr>
          <!-- Configurações fim -->

          <!-- Campos adicionais inicio -->
          <b-tr class="b-table-details" v-if="row.detailsShowing">
            <b-td :colspan="tableFieldsValores.length">
              <h4>
                {{ $t("checklist.form.fieldOptionAdditionalAdd") }}:
                {{ row.item.valor }}
              </h4>
              <table-form-fields
                ref="tableFields"
                :items="row.item.camposAdicionais"
                :allow-add-fields="true"
                :company-options="companyOptions"
                :options-profiles="optionsProfiles"
                :profiles="profiles"
                :userMaster="userMaster"
              >
              </table-form-fields>
            </b-td>
          </b-tr>
          <!-- Campos adicionais fim -->
        </template>
      </b-tbody>
    </b-table-simple>
    <b-button :disabled="disable" size="sm" @click="addValues()">
      {{ $t("checklist.form.fieldOptionAdd") }}
    </b-button>

    <b-button
      :disabled="fieldType == 13"
      size="sm"
      class="ml-2"
      @click="modalOpen"
    >
      {{ $t("checklist.form.fieldOptionImport") }}
    </b-button>

    <!-- <pre class="language-json"><code>{{ items  }}</code></pre> -->
    <!-- <pre class="language-json"><code>{{ tableRows  }}</code></pre> -->
  </div>
</template>

<script>
import CopyFields from "./CopyFields";
import PendencyGenerationNotifyDropdown from "@/components_rms/checklist/pendency/PendencyGenerationNotifyDropdown.vue";
import PendencyPriorityDropdown from "@/components_rms/checklist/pendency/PendencyPriorityDropdown.vue";
import PendencyUniqueOpenedDropdown from "@/components_rms/checklist/pendency/PendencyUniqueOpenedDropdown.vue";

export default {
  name: "TableFormValues",
  components: {
    PendencyGenerationNotifyDropdown,
    PendencyPriorityDropdown,
    PendencyUniqueOpenedDropdown,
    TableFormFields: () => import("./TableFormFields.vue"),
    TableFormResequence: () => import("./TableFormResequence.vue"),
    PendencyDueDateCrud: () =>
      import("@/components_rms/checklist/pendency/PendencyDueDateCrud.vue"),
  },
  mixins: [CopyFields],
  props: {
    items: Array,
    allowAddFields: Boolean,
    companyOptions: Array,
    optionsProfiles: Array,
    profiles: Array,
    userMaster: Boolean,
    fieldType: Number,
  },
  data() {
    return {
      importValues: "",
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsAnomaly: [
        { value: 1, text: "Não" },
        { value: 2, text: "Sim" },
        // { value: 3, text: 'Por Script' },
      ],
      tableFieldsValores: [
        {
          label: "Id",
          key: "sequenciaExibicao",
          sortable: false,
        },
        {
          label: "Valor",
          key: "valor",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
          sortable: false,
        },
      ],
      disable: false,
      tableCount: 0,
    };
  },
  created() {
    if (this.fieldType == 13) {
      this.items.forEach((item) => {
        this.tableCount++;
        if (this.tableCount == 3) this.disable = true;
      });
    }
  },
  mounted: function () {
    this.loadTableRows();
  },
  computed: {
    activetableRowsList() {
      if (!this.tableRows) return [];
      if (this.tableRows == null) return [];
      let itemsAtivos = [];
      for (let campo of this.tableRows.sort(
        (c1, c2) => c1.item.sequenciaExibicao - c2.item.sequenciaExibicao
      )) {
        if (campo.item.ativo) {
          itemsAtivos.push(campo);
        }
      }
      return itemsAtivos;
    },
  },
  methods: {
    addTableRow(item) {
      this.tableRows.push({
        configShowing: false,
        detailsShowing: false,
        item: item,
      });
    },
    // função que adiciona os valores
    addValues() {
      if (this.fieldType == 13) {
        this.tableCount++;
        if (this.tableCount == 3) this.disable = true;
      }
      let value = {
        ativo: true,
        sequenciaExibicao: this.getNextSequenceNumber(this.items),
        valor: "",
        geraAnomalia: 1,
        pendencyGenerationNotify: false,
        pendencyPriority: 2,
        possuiCamposAdicionais: false,
        pendencyDueDate: {
          fieldId: 0,
          formFieldOptionId: 0,
          dueDateIntervalType: 0,
          dueDateIntervalRange: 0,
          formPendencyNotifies: [],
        },
        camposAdicionais: [],
      };
      this.items.push(value);
      this.addTableRow(value);
      this._computedWatchers.activetableRowsList.run();
      this.$forceUpdate();
    },
    cloneValue(valorBase, listaValores) {
      this.copyValue(valorBase, listaValores);
      this._computedWatchers.activetableRowsList.run();
      this.$forceUpdate();
    },
    // função que deleta o valor
    deleteValue(row) {
      if (!row.id || row.id == 0) {
        let indice = this.items.indexOf(row);

        if (indice >= 0) {
          this.items.splice(indice, 1);
        }
      } else {
        row.ativo = false;
      }
      if (this.fieldType == 13) {
        this.tableCount--;
        if (this.tableCount == 3) this.disable = true;
        else this.disable = false;
      }
      // reordenação da sequenciaExibicao apos remover o campo
      let orderedItems = this.getSortedList(this.items);
      for (let i = 0; i < orderedItems.length; i++) {
        orderedItems[i].sequenciaExibicao = i + 1;
      }
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.items) {
        if (this.items.length > 0) {
          this.items.forEach((item) => {
            this.addTableRow(item);
          });
        }
      }
      this._computedWatchers.activetableRowsList.run();
      this.$forceUpdate();
    },
    modalOpen() {
      this.$refs["my-modal"].show();
    },
    modalOk() {
      let sequenceNumber = this.getNextSequenceNumber(this.items);
      let arrayOfLines = this.importValues.match(/[^\r\n]+/g);

      let newValues = [];
      for (let line of arrayOfLines) {
        line = line.trim();
        if (line.length > 0) {
          if (this.valueAlreadyExistsAdd(line, newValues) == false) {
            let value = {
              ativo: true,
              sequenciaExibicao: sequenceNumber,
              valor: line,
              geraAnomalia: 1,
              possuiCamposAdicionais: false,
              camposAdicionais: [],
            };
            newValues.push(value);
            sequenceNumber++;
            value = null;
          }
        }
      }
      for (let value of newValues) {
        this.items.push(value);
      }
      arrayOfLines = null;
      sequenceNumber = null;
      newValues = null;
    },
    valueAlreadyExists(valueCompare) {
      for (let value of this.items) {
        if (value.valor == valueCompare) {
          return true;
        }
      }
      return false;
    },
    valueAlreadyExistsAdd(valueCompare, adicionalValuesArray) {
      if (this.valueAlreadyExists(valueCompare) == true) return true;
      for (let value of adicionalValuesArray) {
        if (value.valor == valueCompare) {
          return true;
        }
      }
      return false;
    },
    updateIdWhenItGoesUp(arrayObject, currentObject) {
      let sortedFields = this.getSortedList(arrayObject);
      let lastField, sorted;

      for (sorted = 0; sorted < sortedFields.length; sorted++) {
        if (
          sortedFields[sorted].sequenciaExibicao ==
          currentObject.sequenciaExibicao
        ) {
          break;
        } else {
          lastField = sorted;
        }
      }
      if (sortedFields[lastField]) {
        sortedFields[lastField].sequenciaExibicao++;
        currentObject.sequenciaExibicao--;
      }
    },
    updateWhenGoDown(arrayObject, currentObject) {
      let sortedFields = this.getSortedList(arrayObject).reverse();
      let firstField, sorted;

      for (sorted = 0; sorted < sortedFields.length; sorted++) {
        if (
          sortedFields[sorted].sequenciaExibicao ==
          currentObject.sequenciaExibicao
        ) {
          break;
        } else {
          firstField = sorted;
        }
      }
      if (sortedFields[firstField]) {
        sortedFields[firstField].sequenciaExibicao--;
        currentObject.sequenciaExibicao++;
      }
    },
    displayConfig(fieldValueRow) {
      if (fieldValueRow) {
        fieldValueRow.configShowing = !fieldValueRow.configShowing;
      }
      this._computedWatchers.activetableRowsList.run();
      this.$forceUpdate();
    },
    setPossuiCamposAdicionais(fieldValueRow) {
      if (fieldValueRow) {
        fieldValueRow.detailsShowing = !fieldValueRow.detailsShowing;
        fieldValueRow.item.possuiCamposAdicionais =
          !fieldValueRow.item.possuiCamposAdicionais;
      }
      this._computedWatchers.activetableRowsList.run();
      this.$forceUpdate();
    },
  },
  watch: {
    items() {
      this.loadTableRows();
    },
  },
};
</script>

<style scoped>
.button {
  margin-left: -1.3%;
}

.import-textarea {
  min-height: 400px;
}

.profile-multiselect {
  max-width: 125px;
  min-width: 125px;
}

.valor {
  width: 94%;
  margin-top: 2%;
}

.table-responsive {
  overflow: visible !important;
}

.table-responsive table td {
  vertical-align: top;
}

.td-acoes {
  padding-top: 18px;
  max-width: 250px;
  min-width: 250px;
}

.td-id {
  padding-top: 21px;
}

.td-input {
  padding-top: 8px;
}
</style>
